<header
  class="py-1 border-bottom d-flex"
  [class.bg-primary]="!isSettingsLoaded"
  [class.settings-color]="isSettingsLoaded"
>
  <div class="d-flex justify-content-start align-items-center ps-4">
    @if (!isHome()) {
      <a adfToolbarButton class="text-white" Icon="bi-arrow-left" [routerLink]="['/']"
        ><i class="bi bi-arrow-left me-2" style="display: inline-block; transform: scaleX(1.5)"></i
      ></a>
    }
    <div class="border-end pe-2">
      <a [routerLink]="['/']" class="d-flex align-items-center mb-0 mb-lg-0 link-dark text-decoration-none">
        <img src="../../../../../assets/andritz/logo.svg" alt="Andritz Logo" width="84" height="16" />
      </a>
      <p class="mb-0 ps-1 pe-2 text-white fs-6">{{ title | titlecase }}</p>
    </div>
  </div>
  @if (isNotError$ | async) {
    <ng-content select="[left-nav]"></ng-content>
    <div class="flex-grow-1 d-flex justify-content-center align-items-center">
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="d-flex justify-content-end align-items-center gap-3 pe-3 border-0">
      <ng-content select="[right-nav]"></ng-content>
    </div>
    <div class="d-flex flex-nowrap align-items-center">
      <adf-expander />
      <adf-notifications />
      <button
        type="button"
        class="btn btn-transparent text-white position-relative"
        ngbTooltip="Help (F1)"
        aria-label="Help"
        aria-keyshortcuts="F1"
        [attr.aria-pressed]="helpOpen$ | async"
        (click)="toggleHelp()"
      >
        <i
          class="bi fs-6"
          [class.bi-question-circle]="!(helpOpen$ | async)"
          [class.bi-question-circle-fill]="helpOpen$ | async"
        ></i>
      </button>
    </div>
  } @else {
    <div class="flex-grow-1"></div>
  }
  <div class="d-flex justify-content-end align-items-center gap-3">
    <div class="border-start ps-3">
      <adf-user-menu [userDisplayName]="getUsername()" [userEmail]="getEmail()" (logout)="onLogout()" />
    </div>
  </div>
</header>
